export enum Locale {
  EN_US = "EN_US",
  ES_MX = "ES_MX",
}
